import { ActionReducer, MetaReducer } from '@ngrx/store';

import { localStorageSync, rehydrateApplicationState } from 'ngrx-store-localstorage';
import { STORAGE } from '../../../../state/storage/storage.action';

/*
    If this breaks again, make sure to also debug the sync storage method in the application container (of each respective app)
 */

export enum LocalStoragePrefix {
    Portal = 'Portal', // Portal data should not be synced over applications. Each app that needs separated localstorage needs a separate value.
    Synced = 'Synced' // Data between these applications will be synced
}
interface SyncReducerOptions {
    localStoragePrefix: LocalStoragePrefix;
    keys?: string[];
}

// Data that is stored/synced for all apps
const STORE_KEYS: string[] = [
    'token',
    'authentication',
    'oauth',
    'user',
    'userPreferences',
    'userfunctions',
    'viewOptions',
    'verifier'
];

// MH specific stored data
export const MH_STORE_KEYS: string[] = [...STORE_KEYS, 'uploadItem'];

export function createLocalStorageSyncReducer({ localStoragePrefix, keys }: SyncReducerOptions): MetaReducer<any> {
    const config = {
        keys: keys ?? STORE_KEYS,
        removeOnUndefined: true,
        rehydrate: true,
        storageKeySerializer: (key: string) => `${localStoragePrefix}_${key}`
    };

    const localSyncReducer = localStorageSync(config);

    return (reducer: ActionReducer<any>): ActionReducer<any> => {
        const syncedReducer = localSyncReducer(reducer);

        return (state: any, action: any) => {
            if (action.type === STORAGE && config.keys.includes(action.payload)) {
                // Merges store state and localstorage state, updates store
                const rehydratedState = rehydrateApplicationState(
                    [action.payload],
                    localStorage,
                    config.storageKeySerializer, // Important: match serializer
                    true
                );
                return { ...state, ...rehydratedState };
            }

            // Merges store state and localstorage state, updates store, updates localstorage
            return syncedReducer(state, action);
        };
    };
}
